import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { ScheduleReportTable } from '../../report/ScheduleReportTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';
import { GroupVisitsByTeamTable } from '../../groups/GroupVisitsByTeamTable';

const WeeklyTotalsTeamDataTable = createQueryDataTable('schedule-report-totals-team');
type RowType = RowOfQueryDataTable<typeof WeeklyTotalsTeamDataTable>;

const columnDefinitions = WeeklyTotalsTeamDataTable.columns([
	{
		header: 'Team',
		key: 'team',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function WeeklyTotalsTeamTable(props: PropsOfQueryDataTable<typeof WeeklyTotalsTeamDataTable>) {
	return (
		<GroupVisitsByTeamTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-team"
			tableComponent={ScheduleReportTable}
			{...props}
		/>
	);
}
